import { Box, Typography } from "@mui/material";
import { Formik, FormikContextType } from "formik";
import { useState } from "react";
import { Notification } from '../../common/Notification/Notification';
import {rsAllocationRuleValidationSchema} from './rsAllocationRuleValidationSchema';
import { RSAllocationRuleForm } from "./RSAllocationRuleForm";
import { notificationType } from "../../types/notifications";
import { saveConfig } from "../../utils/s3FileUtils";
import { useParams } from "react-router-dom";


const AddRSAllocationRulePage = ({ config, selectedRule, onCancel }) => {
  const [notificationState, setNotificationState] = useState<notificationType>({
    open: false, title: '', content: '', level: "success"
  });
  let urlParams = useParams();

  const getInitialValues = () => {
        return {
            SKU: selectedRule?.SKU || '',
            currencyId: selectedRule?.currencyId || '',
            amount: selectedRule?.amount || '',
        };
  };

  return (
    <>
      <Notification notificationState={notificationState} setNotificationState={setNotificationState} />
      <Box maxWidth={500} mx="auto" mt={4}>
        <Typography variant="h4" gutterBottom>
          Add Currency Allocation Rule
        </Typography>
        <Typography variant="h6" gutterBottom>
          Product & Currency Details
        </Typography>
        <Formik
          initialValues={getInitialValues()}
          enableReinitialize
          validationSchema={rsAllocationRuleValidationSchema}
          onSubmit={async (values) => {
            const updatedConfig = { ...config };
            if (!updatedConfig.pluginParams) updatedConfig.pluginParams = {};
            if (!updatedConfig.pluginParams.rsAllocationMap) updatedConfig.pluginParams.rsAllocationMap = {};

            const newRule = {
              currencyId: values.currencyId,
              amount: Number(values.amount),
            };
            updatedConfig.pluginParams.rsAllocationMap[values.SKU] = [newRule];

             await saveConfig({ urlParams, submitData: updatedConfig, setNotificationState });
            setNotificationState({
                            open: true,
                            title: 'Promotion updated successfully',
                            content: 'Promotion Changes were saved!',
                            level: 'success',
                        });
            onCancel();
          }}
        >
          {(formik: FormikContextType<any>) => (
            <form onSubmit={formik.handleSubmit}>
              <RSAllocationRuleForm
                formik={formik}
                config={config}
                onCancel={onCancel}
              />
            </form>
          )}
        </Formik>
      </Box>
    </>
  );
}

export { AddRSAllocationRulePage };
